import { render, staticRenderFns } from "./BaseModalEx.vue?vue&type=template&id=24bcc7f5&scoped=true"
import script from "./BaseModalEx.vue?vue&type=script&lang=js"
export * from "./BaseModalEx.vue?vue&type=script&lang=js"
import style0 from "./BaseModalEx.vue?vue&type=style&index=0&id=24bcc7f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bcc7f5",
  null
  
)

export default component.exports